/* eslint react/jsx-key: off */
import React from "react";
import {
  Create,
  FormTab,
  SaveButton,
  TabbedForm,
  NumberInput,
  SelectInput,
  DisabledInput,
  TextInput,
  ReferenceInput,
  DateInput,
  Toolbar,
  required,
} from "react-admin";

const StockOutEditToolbar = ({ permissions, ...props }) => (
  <Toolbar {...props}>
    <SaveButton
      label="resources.actions.save_and_show"
      redirect="show"
      submitOnEnter={true}
    />
    {permissions === "admin" && (
      <SaveButton
        label="resources.actions.save_and_next"
        redirect={false}
        submitOnEnter={false}
        variant="flat"
      />
    )}
  </Toolbar>
);

const StockOutCreate = function ({ permissions, ...props }) {
  const urlParams = new URLSearchParams(props.location.search);

  return (
    <Create {...props}>
      <TabbedForm toolbar={<StockOutEditToolbar permissions={permissions} />}>
        <FormTab label="resources.stockouts.form.summary" path="">
          <NumberInput
            source="qty"
            defaultValue={parseInt(urlParams.get("qty"))}
            validate={required()}
          />
          <DateInput source="stockOutDate" defaultValue={new Date()} />

          <ReferenceInput
            source="productId"
            reference="products"
            label="resources.stockouts.fields.product"
            perPage={100}
            validate={required()}
            defaultValue={parseInt(urlParams.get("product_id"))}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <ReferenceInput
            source="stockOutRequestId"
            reference="stockoutrequests"
            label="resources.stockouts.fields.stock_out_request"
            validate={required()}
            defaultValue={parseInt(urlParams.get("request_id"))}
          >
            {/* <DisabledInput source="id" /> */}
            <TextInput source="id" disabled />
          </ReferenceInput>
          <ReferenceInput
            source="appUserId"
            reference="appusers"
            validate={required()}
            label="resources.stockouts.fields.user"
            defaultValue={
              JSON.parse(localStorage.getItem("lbtoken")).value.userId
            }
          >
            <SelectInput optionText="username" />
          </ReferenceInput>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

export default StockOutCreate;
